import { CalendarDays, Clock, MapPin, UtensilsCrossed } from "lucide-react";
import { trackSummitInterest } from "@/lib/tracking";

const SUMMIT_URL = "https://wcs.wealthysandeep.com/?src=masterclass_ty&utm_source=masterclass&utm_medium=thankyou&utm_campaign=wcs";
const DETAILS = [
  [CalendarDays, "Sunday, 15 Nov 2026"],
  [Clock, "9 AM – 6 PM"],
  [MapPin, "Sheraton Grand, Whitefield"],
  [UtensilsCrossed, "Lunch & high tea included"],
];
const BULLETS = ["Decode your Wealth Code", "Remove your money blocks", "Build multiple sources of income"];

export const SummitInvite = () => (
  <section className="relative overflow-hidden bg-[#0A0A0A] text-white px-4 py-16 sm:py-24" data-testid="ty-summit-section">
    <div className="summit-glow" aria-hidden />
    <div className="relative max-w-3xl mx-auto text-center">
      <p className="text-[#D4AF37] text-[11px] sm:text-[12px] font-semibold tracking-[0.28em] uppercase">A Special Invitation For Masterclass Registrants</p>
      <h2 className="font-cinzel gold-text font-bold text-[30px] sm:text-[44px] lg:text-[54px] leading-[1.12] mt-5" data-testid="ty-summit-title">
        Wealth Code Summit, Bengaluru 2026
      </h2>
      <p className="text-zinc-300 text-[15px] sm:text-lg mt-5 max-w-xl mx-auto leading-relaxed">
        Take the Wealth Code from online to in-person. One full day, live with Sandeep Gupta.
      </p>
      <ul className="mt-8 grid grid-cols-2 md:flex md:justify-center md:flex-wrap gap-3 text-left md:text-center" data-testid="ty-summit-details">
        {DETAILS.map(([Icon, t]) => (
          <li key={t} className="flex items-center gap-2 rounded-xl border border-[#D4AF37]/25 bg-white/[0.03] px-3 py-2.5 text-[13px] sm:text-sm text-zinc-200">
            <Icon className="w-4 h-4 text-[#D4AF37] shrink-0" />{t}
          </li>
        ))}
      </ul>
      <ul className="mt-8 space-y-3 inline-block text-left">
        {BULLETS.map((b) => (
          <li key={b} className="flex items-center gap-3 text-[15px] sm:text-base text-zinc-100 font-medium">
            <span className="w-2.5 h-2.5 rotate-45 bg-gradient-to-br from-[#F7E7A1] to-[#B8892B] shrink-0" aria-hidden />{b}
          </li>
        ))}
      </ul>
      <p className="mt-8 text-[14px] sm:text-[15px] text-zinc-300" data-testid="ty-summit-price">
        <span className="text-[#E9C766] font-bold">Early Bird: ₹1,499 + GST</span>{" "}
        <span className="text-zinc-400">(regular <span className="line-through">₹2,900</span> + GST)</span>
        <span className="block sm:inline text-zinc-300"> · Only for the first 30 seats</span>
      </p>
      <a href={SUMMIT_URL} target="_blank" rel="noopener noreferrer" onClick={trackSummitInterest} data-testid="ty-summit-cta"
        className="gold-btn mt-7 inline-flex items-center justify-center w-full sm:w-auto rounded-2xl px-8 py-4 text-black font-extrabold text-[15px] sm:text-base transition-transform hover:-translate-y-0.5 active:scale-[0.98]">
        See Summit Details & Book Your Seat
      </a>
      <p className="mt-4 text-[12.5px] text-zinc-400">Bring 2 friends: 3 seats for ₹2,999 + GST</p>
    </div>
  </section>
);
